import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import InfoIcon from '../../../Cutesies/InfoIcon';

function ManagedByExecOnline() {
  return (
    <div
      className={clsx(
        'flex items-center border-teal-600 bg-teal-50',
        'rounded border-1 border-solid px-3 py-2',
      )}
    >
      <div className="mr-2">
        <InfoIcon />
      </div>
      <p className="text-xs text-teal-800">
        <T kind="Managed by ExecOnline. Edits not supported in AdminStudio." />
      </p>
    </div>
  );
}

export default observer(ManagedByExecOnline);
